import { useState } from 'react';
import { Col, Grid, Row, Select } from 'antd';
import { CalendarDate, DeviceWrapper, InputCalendar, PageContainer } from '@/components';
import { ActivityReportDesktop, ActivityReportMobile } from '../reserve/ActivityReport';
import { getEndOfCurrentMonth, getStartOfCurrentMonth } from '@/utils/date';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { fetchLogTypes } from '@/services/activity.service';

export function ActivityReportPage() {

  const typesQuery = useQuery({
    retry: 0,
    queryKey: ['/rest/activity-logs/types'],
    queryFn: () => fetchLogTypes(),
  });

  const [t] = useTranslation(['common']);
  const { lg } = Grid.useBreakpoint();
  const start = getStartOfCurrentMonth();
  const end = getEndOfCurrentMonth();


  const [fromDate, setFromDate] = useState(start.str);
  const [toDate, setToDate] = useState(end.str);
  const [prefs, setPrefs] = useState<{
    actionTypes: string[];
  }>({
    actionTypes: [],
  });

  // API responds with an object map under `payload`
  const types = typesQuery?.data?.payload ?? {};
  const filterKeys = Object.keys(types ?? {});

  return (
    <PageContainer noPadding bodyClassName="h-full" title={t('common:labels.activity-report')}>
      <Row
        className={
          classNames('w-full',
            lg ? 'mt-2 !mx-auto' : 'mt-3 !mx-0'
          )
        }
        gutter={[16, 16]}
      >
        <Col xxl={4} xl={6} lg={8} span={12}>
          <Select
            allowClear
            placeholder={t('common:labels.action-type')}
            className="w-full min-h-[38px] rounded-lg"
            mode="multiple"
            defaultValue={undefined}
            loading={typesQuery.isFetching}
            onChange={(values) => setPrefs({ ...prefs, actionTypes: values })}
            options={filterKeys.map(key => ({ key, value: key, label: types[key] }))}
            filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
          />
        </Col>
        <Col xxl={4} xl={6} lg={8} span={12}>
          <InputCalendar
            size="large"
            value={fromDate}
            defaultDate={start.date as any}
            className="text-center"
            placeholder={t('common:labels.start-date')}
            onChange={(d: CalendarDate) => setFromDate(d.strEn)}
          />
        </Col>
        <Col xxl={4} xl={6} lg={8} span={12}>
          <InputCalendar
            size="large"
            value={toDate}
            defaultDate={end.date as any}
            className="text-center"
            placeholder={t('common:labels.end-date')}
            onChange={(d: CalendarDate) => setToDate(d.strEn)}
          />
        </Col>
      </Row>
      <DeviceWrapper show={['desktop']}>
        <ActivityReportDesktop fromDate={fromDate} toDate={toDate} actionTypes={prefs.actionTypes} />
      </DeviceWrapper>
      <DeviceWrapper show={['mobile']}>
        <ActivityReportMobile fromDate={fromDate} toDate={toDate} actionTypes={prefs.actionTypes} />
      </DeviceWrapper>
    </PageContainer>
  );
}

export default ActivityReportPage;
